<template>
<div class="customerWrapper">
    <div class="customer_header">
        <el-button size="mini" type="primary" @click="oop()">{{$t('other.a1084')}}</el-button>
        <el-button size="mini" type="primary" @click="getUserMessage()">{{$t('other.a1085')}}</el-button>
        <el-button size="mini" type="primary">{{$t('other.a1086')}}</el-button>
        <span v-show="targetUserName" class="merber">{{$t('other.a1087')}}：{{targetUserName}} {{$t('other.a363')}}</span>
    </div>
    
 
</div>

  
</template>

<script>
import config from './config'
import api from '../../api/moudles/customer'
import { mapState, mapMutations } from 'vuex'
export default {
data(){
return{
  


}
},

computed:{
    ...mapState({
        userId: state => state.shopaccess.userInfo.userId,
       
    }),

 
},

watch:{
  

  

},

created(){
//    this.init()
   this.connectWebsocket()
},
mounted(){
   

},
methods:{
    //
    init(){
       
           
    },

 
   

    //websock链接
    connectWebsocket(){
         const wsuri = "ws://47.57.9.89:8101/ws";
        this.websock = new WebSocket(wsuri);
        console.log(this.websock)
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;

    },
     websocketonopen(){ //连接建立之后执行send方法发送数据
       this.$message.success(this.$t('other.a371'))
        
      },
      websocketonerror(){//连接建立失败重连
        this.$message.success(this.$t('other.a372'))
      },
      websocketonmessage(e){ //数据接收
        const redata = JSON.parse(e.data);
        console.log('字符串',redata)
      },
      websocketsend(Data){//数据发送
        this.websock.send(Data);
      },
      websocketclose(e){  //关闭
        console.log('断开连接',e);
      },

}
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";
.customerWrapper{
      @include main-right-content();
      
      .customer_header{
          height: 30px;
          border-bottom: 1px solid #eeee;
          padding: 10px 0;

          .merber{
              margin-left:20px
          }

      }
     
     


    
        

    
    

}

</style>